var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeadTraderComing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 42,
    viewBox: "0 0 59 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3258 21C21.0241 21 23.6119 19.8938 25.5199 17.9246C27.4279 15.9555 28.4997 13.2848 28.4997 10.5C28.4997 7.71523 27.4279 5.04451 25.5199 3.07538C23.6119 1.10625 21.0241 0 18.3258 0C15.6275 0 13.0398 1.10625 11.1318 3.07538C9.22381 5.04451 8.15192 7.71523 8.15192 10.5C8.15192 13.2848 9.22381 15.9555 11.1318 17.9246C13.0398 19.8938 15.6275 21 18.3258 21ZM14.6934 24.9375C6.86428 24.9375 0.521484 31.4836 0.521484 39.5637C0.521484 40.909 1.57862 42 2.88215 42H33.7695C35.073 42 36.1302 40.909 36.1302 39.5637C36.1302 31.4836 29.7874 24.9375 21.9582 24.9375H14.6934Z",
    fill: "#22224E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.875 14.4219H39.375V21.7135H34.875V14.4219ZM42.75 11.2969H47.25V24.8385H42.75V11.2969Z",
    fill: "#10F48B",
    stroke: "#10F48B",
    strokeWidth: 1.76718,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45 26.9173V24.834",
    stroke: "#10F48B",
    strokeWidth: 1.76718,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.625 10.2539H55.125V14.9414H50.625V10.2539Z",
    fill: "#10F48B",
    stroke: "#10F48B",
    strokeWidth: 1.76718,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.125 14.4193V9.21094M52.875 21.7109V14.9401M52.875 10.2526V6.08594",
    stroke: "#10F48B",
    strokeWidth: 1.76718,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadTraderComing);
export default __webpack_public_path__ + "static/media/leadTraderComing.b0ee4d005ae6152024f9c5afa13c5012.svg";
export { ForwardRef as ReactComponent };